import {Component, Input, OnInit, AfterViewInit} from '@angular/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'nf-task-status',
  templateUrl: './task-status.component.html',
  styleUrls: ['./task-status.component.css']
})
export class TaskStatusComponent implements OnInit, AfterViewInit {
  dataSubscription: Subscription = null;
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  group: any = {}; // 当前组件分组数据
  pulse: any = {}; // 当前组件行数据
  column: any = {}; // 当前组件列数据
  taskStatusData = [];
  progressColumn: any;
  @Input('nfBoardData') set ChangeBoardData(data: any) {
    if (data) {
      this.boardData = data;
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
  }
  @Input('nfColumnData') set ChangeColumnData(data: any) {
    if (data) {
      this.column = data;
    }
  }
  @Input('nfPulseData') set ChangePulseData(data: any) {
    if (data) {
      this.pulse = data;
    }
  }
  constructor() { }

  ngOnInit(): void {
    this.boardColumnData.forEach(item => {
      if (item.type === 'taskProgress') {
        this.progressColumn = item;
      }
    });
    this.taskStatusData = [];
    if (this.pulse.children && this.pulse.children.length) {
      this.pulse.children.forEach((item) => {
        let taskStatus = 'notFinished';
        if (item.columnValues[this.progressColumn.id] && ( item.columnValues[this.progressColumn.id].progress === 100 || (item.columnValues[this.progressColumn.id].value && item.columnValues[this.progressColumn.id].value.symbol && item.columnValues[this.progressColumn.id].value.symbol === 'complete'))) {
          taskStatus = 'done';
        }
        const newObj = {
          id: item.id,
          title: item.name,
          status: taskStatus
        };
        this.taskStatusData.push(newObj);
      });
    }
    const obj = {};
    this.taskStatusData = this.taskStatusData.reduce((cur, next) => {
      obj[next.id] ? '' : obj[next.id] = true && cur.push(next);
      return cur;
    }, []);
  }
  ngAfterViewInit() {
  }
}
